<div class="rename-session-container">
  <form [formGroup]="renameForm" (ngSubmit)="save()">
    <div class="field mb-4">
      <label for="sessionName" class="block mb-2 font-medium"
        >{{ 'SESSION_NAME' | translate }}<span class="text-danger">*</span></label
      >
      <input
        id="sessionName"
        type="text"
        pInputText
        formControlName="sessionName"
        class="w-100 p-2 border border-gray-300 rounded"
        placeholder="{{ 'ENTER_SESSION_NAME' | translate }}"
      />
    </div>

    <div class="d-flex justify-content-end mt-4 footer-actions">
      <p-button
        type="button"
        label="{{ 'CANCEL' | translate }}"
        styleClass="p-button-outlined p-button-secondary"
        (click)="close()"
        [disabled]="Flags.isServiceTriggered"
      ></p-button>
      <p-button
        type="submit"
        label="{{ 'SAVE' | translate }}"
        styleClass="p-button-primary"
        [disabled]="renameForm.invalid || Flags.isServiceTriggered"
        [loading]="Flags.isServiceTriggered"
      ></p-button>
    </div>
  </form>
</div>
